import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2';
const ErrorArea = (props) => {
    return (
        <>
            <section id="error_area" className="ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3">

                           {props.isLoading? 
                           <div className="erorr_wrapper">
                         
                           <div className="spinner-border text-dark" role="status">
                            <span className="sr-only">Loading...</span>
                            </div>
                           <h3 className='mb-n3 text-dark'>Please wait, loading...</h3>
                         
                           </div>
                           :<div className="erorr_wrapper">
                                {/* <h1>Oops{props.count}</h1> */}
                                <i className="fa fa-search-minus fa-5x text-dark" aria-hidden="true"></i>

                                <h3 className='mb-n3 text-dark'>Sorry, No data available here</h3>
                                {/* <form onSubmit={(e)=> {e.preventDefault(); Swal.fire('Search Error', 'No Results Found', 'warning')}}>
                                    <div className="input-group">
                                        <input type="text" className="form-control" required/>
                                        <button><i className="fa fa-search"></i></button>
                                    </div>
                                </form> */}
                                <Link to="/" className="theme-btn-one btn-black-overlay btn_md">Back To Home Page</Link>
                            </div>}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ErrorArea